import { Form, useFormContext, useStore } from "@/components/form";
import { Stack, Typography } from "@mui/material";
import AutoModeIcon from '@mui/icons-material/AutoMode';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import { Dialog, ModalHeader, useOpenModal } from "@/components/modal";
import ArticuloPrecioGenForm from "./articulo-precio-gen-form";


export default function ArticuloPrecioFormFields() {
    const openModal = useOpenModal();

    const form = useFormContext<{ precios: number[], costo: number }>();

    const costo = useStore(form.store, state => state.values.costo);

    return <Stack gap={2}>
        <Typography variant="h6">Costo/Precios</Typography>
        {/* Costo, IVA */}
        <Stack flexDirection={"row"} gap={2} flexWrap={"wrap"} justifyContent={"stretch"}>
            <Stack gap={1} flex={"2 1 200px"}>
                <Form.MonedaField name="costo" label="Costo" size="small"
                    onKeyDown={e => {
                        if (e.key !== "Enter" || e.shiftKey) return;
                        e.preventDefault();
                        if (costo) openModal("generatePrecios");
                    }}
                    slotProps={{
                        input: {
                            endAdornment: <Form.IconButton edge={"end"} onClick={() => openModal("generatePrecios")} disabled={!costo}>
                                <AutoModeIcon />
                            </Form.IconButton>
                        }
                    }}
                />
            </Stack>
            <Stack minWidth={"100px"} flex={1}>
                <Form.Select name="iva" label="IVA" size="small">
                    <Form.Select.Option value={10}>10%</Form.Select.Option>
                    <Form.Select.Option value={5}>5%</Form.Select.Option>
                    <Form.Select.Option value={0}>Exenta</Form.Select.Option>
                </Form.Select>
            </Stack>
        </Stack>

        {/* Precios */}
        <form.Field name="precios" mode="array">
            {field => <Stack gap={2}>
                {field.state.value.map((_, i) => (
                    <Stack key={i} direction={"row"} alignItems={"center"} gap={1}>
                        <Stack flex={1}>
                            <Form.MonedaField name={`precios[${i}]`} label={`Precio ${i + 1}`} size="small" />
                        </Stack>
                        <Form.IconButton onClick={() => field.removeValue(i)}><ClearIcon /></Form.IconButton>
                    </Stack>
                ))}
                {field.state.value.length < 3 &&
                    <Form.Button startIcon={<AddIcon />} onClick={() => field.pushValue("" as unknown as number)} >
                        Agregar Precio
                        <Form.ErrorText name="precios" />
                    </Form.Button>}
            </Stack>}
        </form.Field>

        {/* Modal */}
        <Dialog code="generatePrecios">
            <ModalHeader>Generar Precios</ModalHeader>
            <ArticuloPrecioGenForm
                defaultPercentage={{ precio1Per: 50, precio2Per: 10, precio3Per: 20 }}
                costo={costo}
                onSubmit={async v => {
                    form.setFieldValue("precios", v)
                    form.focusField("iva")
                }}
                padding={3}
            />
        </Dialog>
    </Stack>
}